import { IFileAccess } from '../interfaces/file.component.interface';

/** Дефолтные доступы на компонент */
export const DEFAULT_ACCESS: IFileAccess = {
    add: true,
    edit: true,
    delete: true,
};

/**
 * Массив расширений, которые являются картинками
 */
// eslint-disable-next-line capitalized-comments
// prettier-ignore
export const IMG_EXTENSIONS: string[] = [
    'ase', 'art', 'bmp', 'blp', 'cd5', 'cit', 'cpt', 'cr2', 'cut', 'dds', 'dib', 'djvu',
    'egt', 'exif', 'gif', 'gpl', 'grf', 'icns', 'ico', 'iff', 'jng', 'jpeg', 'jpg', 'jfif',
    'jp2', 'jps', 'lbm', 'max', 'miff', 'mng', 'msp', 'nitf', 'ota', 'pbm', 'pc1', 'pc2',
    'pc3', 'pcf', 'pcx', 'pdn', 'pgm', 'PI1', 'PI2', 'PI3', 'pict', 'pct', 'pnm', 'pns',
    'ppm', 'psb', 'psd', 'pdd', 'psp', 'px', 'pxm', 'pxr', 'qfx', 'raw', 'rle', 'sct',
    'sgi', 'rgb', 'int', 'bw', 'tga', 'vtf', 'xbm', 'xcf', 'xpm', '3dv', 'amf', 'ai',
    'awg', 'cgm', 'cmx', 'dxf', 'e2d', 'egt', 'eps', 'fs', 'gbr', 'svg', 'stl', 'vrml',
    'x3d', 'sxd', 'v2d', 'vnd', 'wmf', 'emf', 'art', 'xar', 'png', 'webp', 'jxr', 'hdp',
    'wdp', 'cur', 'ecw', 'iff', 'lbm', 'liff', 'nrrd', 'pam', 'pcx', 'pgf', 'sgi', 'rgb',
    'rgba', 'bw', 'int', 'inta', 'sid', 'ras', 'sun', 'tga'
];

/** Регулярное выражение для нахождения расширения файла */
export const EXR_SEARCH_REG = new RegExp('[^.]+$');

/** Дефолтный alias загрузки */
export const DEFAULT_ALIAS = 'upl-file-';

/** Список расширений, которые можно открывать в 3D */
export const BIM_EXTENSIONS = ['ifc'];

/** Ссылка на метод для удаления файла */
export const DEFAULT_FILE_DELETE_URL = '/files/front_files/remove_file';

/** Регулярное выражение для проверки имени файла (без расширения) */
export const FILE_NAME_REG = new RegExp('^[^<>:;,?"*|/]+$');

/** Наименование событий, которые могу прийти от компонента таблицы */
export enum ETableEvent {
    FileSignDownload = 'fileSignDownload',
    FileDownload = 'fileDownload',
    FileShowSignList = 'fileShowSignList',
    FileDownloadZIP = 'fileDownloadZIP',
    FileRemove = 'fileRemove',
}

/** Список модулей в которых используется класс FileFactor */
export const FILE_FACTOR_MODULE_LIST = ['factor', 'designer_relations'];

/** Список классов - состояний иконки подписанного файла */
export enum ESignIconValidationClass {
    success = 'success',
    error = 'error',
}
/** Урл для скачивания фала */
export const FILE_DOWNLOAD_BY_ID_GET_URL = '/files/front_files/download?id=';

/** Максимальный вес подписи к файлу */
export const SIGN_FILE_MAX_FILESIZE = 1048576;

export enum EFileOutputEvents {
    afterSign = 'afterSign',
    removeFileUuids = 'removeFileUuids',
}
